module.exports = __webpack_public_path__ + "static/media/access-key.dc07b4cb.svg";